<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-70pc active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeading }}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-primary mr-2" (click)="resendInviteAll()" [hidden]="!inviteButtonText" 
                    [ngClass]="{ 'disabled': !gridData || gridData.length == 0 }">
                    {{ inviteButtonText }}
                </button>
                <button type="button" class="btn eod-btn-primary mr-2" (click)="saveApproverAssignment()" [hidden]="hideSave"
                    [ngClass]="{'disabled': disableSave }">
                    {{ 'save_text' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="row">
            <div class="block padding-top-10 heightCalc-5">
                <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-12">
                    <!----------------------Start Grid--------------------------->
                    <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                        [gridFilterItems]="gridFilterItems" (filterChanged)="fnGridFilterChanged($event)"
                        (onCellClick)="fnOnGridCellClick($event)">
                    </app-grid>
                    <!----------------------End Grid--------------------------->
                </div>
            </div>
        </div>
    </div>
</div>
<cost-centre-list-panel [hidden]="!showCostCentreListPanel" [(selectedApprover)]="selectedApproverData"
    (closePanel)="closeCostCentreListPanel($event)">
</cost-centre-list-panel>